function init (): void {
    let recipePortion = parseInt(<string>document.querySelector('.portion')?.textContent);

    const increaseButton = document.querySelector<HTMLElement>('.increase-portion');
    const decreaseButton = document.querySelector<HTMLElement>('.decrease-portion');

    if (increaseButton) {
        increaseButton.addEventListener('click', () => {
            recipePortion++;
            calculateNewQuantities(recipePortion);
        });
    }

    if (decreaseButton) {
        decreaseButton.addEventListener('click', () => {
            if (recipePortion > 1) {
                recipePortion--;
                calculateNewQuantities(recipePortion);
            }
        });
    }
}

function calculateNewQuantities (newRecipePortion: number): void {
    const portionElement = document.querySelector('.portion');
    let basePortion: number | undefined;
    if (portionElement) {
        basePortion = parseInt(<string>portionElement.getAttribute('data-base-portion'));
        portionElement.textContent = newRecipePortion.toString();
    }
    if (typeof basePortion !== 'undefined') {
        const ratio = newRecipePortion / basePortion;
        for (const quantityElement of document.querySelectorAll<HTMLElement>('.quantity')) {
            let newQuantity = ratio * Number(<string>quantityElement.getAttribute('data-base-quantity'));
            if (newQuantity > 10) {
                newQuantity = Math.round(newQuantity);
            } else {
                // 1 after-digit max
                newQuantity = Math.round((newQuantity + Number.EPSILON) * 10) / 10;
            }
            quantityElement.textContent = newQuantity.toString();
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
} else {
    init();
}

export {};
